module.exports = __webpack_public_path__ + "img/symbol_0.88cfe1f9.png";